const doc = [({"en":({"js":({"nemoa":({"activities":({"show":({"politics":({"politics":"Politics"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;